import React, { Fragment, useContext } from "react";
import moment from "moment";
import {useQueryClient} from "react-query";
import { useAirports } from "../../../services/airports";
import { Movements } from "../../../modules/Trips/components/TripListDialogs/MovementsTooltip";
import RouteMap from "../RouteMap";
import { Icon, IconButton } from "@material-ui/core";
import SystemContext from "../../../SystemContext";

const AirportData = (props) => {
  const queryClient = useQueryClient();

  const airport = useAirports({queryClient, extraKeys:[props.airportCode], useCache: true});

  return (<div style={props.style}>{airport.data?airport.data[0][props.field]:props.airportCode}</div>)
}

const ExternalScreen = (props) => {
  const doubleWidth = props.doubleWidth || false;
  const width = doubleWidth ? 640 : 320;
  const height = doubleWidth ? 400 : 200;
  const {tripData, classes} = props;

  const SystemData = useContext(SystemContext);

  const showBigMap = (tripData) => {
    const {airlineCode, flightNo} = tripData;
    SystemData.openAlert(
      `Route for ${airlineCode}${flightNo}`,
      (
        <div style={{width: (width * 2 + 40), height: (height * 2 + 40)}}>
          <RouteMap
            width={width * 2}
            height={height * 2}
            record={{
              uuid: tripData.uuid,
              origin: tripData.originAirportCode,
              destination: tripData.destinationAirportCode,
              tripRoute:`${tripData.originAirportCode}-${tripData.destinationAirportCode}`,
              onwardRoutes:"",
              progress: Math.max(Math.min(moment.utc().diff(moment.utc(tripData.scheduledDepartureTimeUtc),'min')/moment.utc(tripData.scheduledArrivalTimeUtc).diff(moment.utc(tripData.scheduledDepartureTimeUtc),'min') * 100, 100),0)
            }}
          />
        </div>
      ),
      {zIndex: 5000, maxWidth: (width * 2 + 80), fullWidth: false}
    );
  }

  const leg = tripData;
  
  const scheduledData = {
    std: leg.scheduledDepartureTimeUtc,
    etd: leg.estimatedDepartureTimeUtc,
    sta: leg.scheduledArrivalTimeUtc,
    eta: leg.estimatedArrivalTimeUtc,
    bloff: leg.bloff,
    takeoff: leg.takeoff,
    ldg: leg.ldg,
    blon: leg.blon,
    etaUTC: leg.etaUTC,
  }

  return (
    <Fragment>
      <div style={{ padding: 10, paddingTop: 0, textAlign: "center"}}>
        <AirportData
          style={{fontSize: 12, padding: 4, paddingBottom: 2, width: "100%"}}
          airportCode={tripData.originAirportCode}
          field='airportName'
        />
        <div style={{fontSize: 12, transform: "rotate(180deg)"}}><Icon style={{fontSize: 10}}>flight</Icon></div>
        <AirportData
          style={{fontSize: 12, padding: 4, paddingTop: 2, width: "100%"}}
          airportCode={tripData.destinationAirportCode}
          field='airportName'
        />
      </div>
      <Movements classes={classes} data={scheduledData} showScheduled={true}/>
      <div style={{width: "100%", textAlign: "center", marginTop: 10}}>
        <div style={{display: "inline-block", position: "relative", maxWidth: width, width: width, backgroundColor: "rgba(130,130,130,0.8)"}}>
          <RouteMap
            width={width}
            height={height}
            record={{
              uuid: tripData.uuid,
              origin: tripData.originAirportCode,
              destination: tripData.destinationAirportCode,
              tripRoute:`${tripData.originAirportCode}-${tripData.destinationAirportCode}`,
              onwardRoutes:"",
              progress: Math.max(Math.min(moment.utc().diff(moment.utc(tripData.scheduledDepartureTimeUtc),'min')/moment.utc(tripData.scheduledArrivalTimeUtc).diff(moment.utc(tripData.scheduledDepartureTimeUtc),'min') * 100, 100),0)
            }}
          />
          <div onClick={()=> showBigMap(tripData)} style={{cursor: "pointer", position: "absolute", top: 1, right: 1, fontSize: "12px", color: "rgba(0,0,0,1)"}}><Icon fontSize={"inherit"}>aspect_ratio</Icon></div>
        </div>
      </div>
    </Fragment>
  );
}

export default ExternalScreen;
